import _ from 'lodash';
import qs from 'qs';
import axios from '../axios';
import { checkResponse, getProjectId, getNoNullObj } from '../utils';
import { apiV2 } from '../utils/constant';


/**
 * @function getSearchQuickDefs
 * @desc 快速试用配置
 * @param {String} identPrefix 定义key值前缀，比如A
 * @returns {Object} object 返回配置信息
 * @returns {Object} object.key 标记
 * @returns {Object} object.description 目标	
 * @returns {String} object.testUrl 测试URL	
 * @returns {String} object.formalUrl 正式URL
 */
function getSearchQuickDefs(identPrefix) {
  return axios
    .get(`${apiV2}/quickTry/searchQuickDefs?identPrefix=${identPrefix}`)
    .then(checkResponse)
}
/**
 * @function quickTryUserList
 * @desc 用来获取试用账号
 * @returns {Object} test 测试环境账号	
 * @returns {Object} production 生产环境账号
 */
function quickTryUserList() {
  return axios
    .get(`${apiV2}/quickTry/userList`)
    .then(checkResponse)
}



/**
 * @function getDefaultConfigure
 * @desc 获取默认的下载配置（包含app，小程序，下载器）
 * @returns {Object} configure 返回配置信息
 * @returns {Object} configure.app 返回app的配置信息
 * @returns {String} configure.app.file 返回app的oss下载地址
 * @returns {String} configure.app.name 返回app的名称
 * @returns {String} configure.app.updateDate 返回app的更新时间
 * @returns {String} configure.app.version 返回app的更新版本
 * @returns {Object} configure.wx 返回微信小程序配置，Object内部结构同app
 * @returns {Object} configure.downloader 返回下载器配置，Object内部同app
 */
function getDefaultConfigure() {
  return axios.get('/api/v1/utils/allConfig?projectId=0').then(checkResponse);
}

/**
 * @function getProjectName
 * @desc 主要用于在导航中获取项目名称
 * @param {Number} projectId 项目id
 * @returns {String} result.title 项目名称
 * @returns {Array} result.navs 导航信息数组
 */
function getProjectName(projectId) {
  const currentProjectId = projectId || getProjectId();
  if (currentProjectId) {
    return axios.get(`/api/v1/projects/${currentProjectId}/navs`).then(({ data }) => {
      return data.title;
    });
  }
  return Promise.resolve();
}
/**
 * @function getConfigProjectName
 * @desc 主要用于在导航中获取项目名称
 * @param {Number} projectId 项目id
 * @returns {String} result.title 项目名称
 * @returns {Array} result.navs 导航信息数组
 */
function getConfigProjectName(projectId) {
  const currentProjectId = projectId || getProjectId();
  if (currentProjectId) {
    return axios.get(`/api/v1/projects/${currentProjectId}/config/navs`).then(({ data }) => {
      return data.title;
    });
  }
  return Promise.resolve();
}
/**
 * @function getProjectNav
 * @desc 用于获取项目的导航信息
 * @param {String} projectId 项目id
 */
function getProjectNav(projectId) {
  return axios.get(`/api/v1/projects/${projectId}`).then(checkResponse);
}

/**
 * @function getNavMenu
 * @desc 主要用于在导航中获取导航数组
 * @todo 该接口同getProjectName，要在之后的接口替换中干掉
 * @param {Number} projectId 项目id
 * @returns {String} result.title 项目名称
 * @returns {Array} result.navs 导航信息数组
 */
function getNavMenu(projectId) {
  const currentProjectId = projectId || getProjectId();
  if (currentProjectId) {
    return axios.get(`/api/v1/projects/${currentProjectId}/navs`).then(({ data }) => {
      return data.navs;
    });
  }
  return Promise.resolve();
}
/**
 * @function getConfigNavMenu
 * @desc 主要用于在导航中获取导航数组
 * @todo 该接口同getProjectName，要在之后的接口替换中干掉
 * @param {Number} projectId 项目id
 * @returns {String} result.title 项目名称
 * @returns {Array} result.navs 导航信息数组
 */
function getConfigNavMenu(projectId) {
  const currentProjectId = projectId || getProjectId();
  if (currentProjectId) {
    return axios.get(`/api/v1/projects/${currentProjectId}/config/navs`).then(({ data }) => {
      return data.navs;
    });
  }
  return Promise.resolve();
}

/**
 * @function getRole
 * @desc 获取角色信息
 * @param {Number} projectId 项目id
 * @returns {Object} 角色信息，具体包含以下数据 { name: 角色名称, roleableId: 角色id, roleableType: 角色类型 }
 */
// function getRole (projectId) {
//   const currentProjectId = projectId || getProjectId()
//   if (currentProjectId) {
//     return axios.get(`/api/v1/projects/${currentProjectId}/users/role`).then(({ data }) => { return data.data })
//   }
//   return Promise.resolve()
// }

/**
 * @function getRole
 * @desc 获取角色信息
 * @returns {Object} 角色信息，具体包含以下数据 { name: 角色名称, roleableId: 角色id, roleableType: 角色类型 }
 */
function getRole(roleId) {
  const params = getNoNullObj({
    roleId,
  });
  return axios
    .get(`/api/v1/projects/${getProjectId()}/config/role?${qs.stringify(params)}`)
    .then(checkResponse);
}

/**
 * @function getCurrentProjectConfigured
 * @desc 获取当前项目的配置信息
 * @param {Number} projectId 项目id
 * @returns {Object} 返回数据同 getDefaultConfigure
 */
function getCurrentProjectConfigured(projectId) {
  const currentProjectId = projectId == null ? getProjectId() : projectId;
  if (currentProjectId != null) {
    return axios.get(`/api/v1/projects/${currentProjectId}/configured`).then(({ data }) => ({
      ..._.omit(data.data, ['app', 'wx', 'downloader']),
      app: _.get(data, 'data.app', null),
      weapp: _.get(data, 'data.wx', null),
      downLoader: _.get(data, 'data.downloader', null),
    }));
  }
  return {};
}

/**
 * @function getAllProjectConfigured
 * @desc 获取所有配置信息
 * @returns {Array} 返回数据同 getDefaultConfigure
 */
function getAllProjectConfigured() {
  return axios.get(`/api/v1/projects/configurations`).then(({ data }) => {
    return data.data;
  });
}

/**
 * @function removeToken
 * @desc 清除调研工场token的方法
 * @returns {Boolean} 是否清除成功
 */
function removeToken() {
  return axios.get(`/api/v1/user_sessions/sf_logout`).then(checkResponse);
}

export {
  getSearchQuickDefs,
  quickTryUserList,
  getDefaultConfigure,
  getProjectName,
  getConfigProjectName,
  getRole,
  getNavMenu,
  getConfigNavMenu,
  getProjectNav,
  getCurrentProjectConfigured,
  getAllProjectConfigured,
  removeToken,
};
